import AboutCard from "../../Components/About-card/AboutCard";
import "./About.css";

function About() {
	return (
		<div className="about-main-box-container">
			<AboutCard />
		</div>
	);
}

export default About;
